import {PaymentWay} from "../../../../types/payment";
import {Price} from "../../../../types/cart";
import {NicePaymentGateway} from "./NIcePaymentGateway";
import {PayPalPaymentGateway} from "./PayPalPaymentGateway";

declare global {
  interface Window {
    nicepaySubmit: any;
    nicepayClose: any;
    goPay: any;
  }
}

interface PaymentGatewayProps {
  price: Price;
  cartIdxes: number[];
  isClickedPayButton: Boolean;
  resetClickedPayButton: (_: boolean) => void;
  paymentWay: PaymentWay | null;
  couponHistoryIdx: number | null;
  affiliateCodeIdx: number | null;
  couponCodeIdx: number | null;
}

export function PaymentGateway(props: PaymentGatewayProps) {
  const {
    price,
    cartIdxes,
    isClickedPayButton,
    resetClickedPayButton,
    paymentWay,
    couponHistoryIdx,
    affiliateCodeIdx,
    couponCodeIdx,
  } = props;

  const pgRouter = () => {
    console.log(paymentWay)
    switch (paymentWay) {
      case PaymentWay.CARD:
        return <NicePaymentGateway price={price} cartIdxes={cartIdxes}
                                   isClickedPayButton={isClickedPayButton}
                                   resetClickedPayButton={resetClickedPayButton}
                                   paymentWay={paymentWay}
                                   couponCodeIdx={couponCodeIdx}
                                   couponHistoryIdx={couponHistoryIdx}
                                   affiliateCodeIdx={affiliateCodeIdx}
        />;
      case PaymentWay.VBANK:
        return <NicePaymentGateway price={price} cartIdxes={cartIdxes}
                                   isClickedPayButton={isClickedPayButton}
                                   resetClickedPayButton={resetClickedPayButton}
                                   paymentWay={paymentWay}
                                   couponCodeIdx={couponCodeIdx}
                                   couponHistoryIdx={couponHistoryIdx}
                                   affiliateCodeIdx={affiliateCodeIdx}
        />;
      case PaymentWay.PAYPAL:
        return <PayPalPaymentGateway price={price} cartIdxes={cartIdxes}
                                     isClickedPayButton={isClickedPayButton}
                                     resetClickedPayButton={resetClickedPayButton}
                                     paymentWay={paymentWay}
                                     couponCodeIdx={couponCodeIdx}
                                     couponHistoryIdx={couponHistoryIdx}
                                     affiliateCodeIdx={affiliateCodeIdx}
        />;
      default:
        return alert("일시적인 문제가 발생했습니다.\n다시 시도해주세요.")
    }
  }

  return <>{pgRouter()}</>
}
